"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppConfig = void 0;
const lodash_1 = __importDefault(require("lodash"));
class AppConfig {
    constructor(switchboard = false, liveStats = false, keyBindings = new Set(), queueControl = false, chat = false, routing = '', mailTemplate = {
        "subject": "",
        "body": ""
    }) {
        this.switchboard = switchboard;
        this.liveStats = liveStats;
        this.keyBindings = keyBindings;
        this.queueControl = queueControl;
        this.chat = chat;
        this.routing = routing;
        this.mailTemplate = mailTemplate;
    }
}
exports.AppConfig = AppConfig;
class applicationConfiguration {
    constructor() {
        this.$get = (remoteConfiguration, $log) => {
            if (remoteConfiguration.isAgent()) {
                remoteConfiguration.getBoolean("showQueueControls").then((value) => this.ccAgentConfig.queueControl = value);
            }
            remoteConfiguration.getBoolean("disableChat").then((value) => {
                if (value) {
                    this.defaultConfig.chat = false;
                    this.switchBoardConfig.chat = false;
                }
            });
            remoteConfiguration.get('email', false).then((template) => {
                if (lodash_1.default.has(template, ['subject']) &&
                    lodash_1.default.has(template, ['body'])) {
                    this.defaultConfig.mailTemplate =
                        this.switchBoardConfig.mailTemplate =
                            this.ccAgentConfig.mailTemplate = template;
                }
                else {
                    $log.warn('email template configured is not containing subject or email field, default empty template will be used');
                }
            });
            const _getCurrentAppConfig = () => {
                if (remoteConfiguration.hasSwitchBoard()) {
                    return this.switchBoardConfig;
                }
                if (remoteConfiguration.isAgent()) {
                    return this.ccAgentConfig;
                }
                return this.defaultConfig;
            };
            return {
                getCurrentAppConfig: _getCurrentAppConfig
            };
        };
        this.defaultConfig = new AppConfig();
        this.defaultConfig.keyBindings = new Set(["F10"]);
        this.defaultConfig.chat = true;
        this.defaultConfig.routing = "interface";
        this.ccAgentConfig = new AppConfig();
        this.ccAgentConfig.liveStats = true;
        this.ccAgentConfig.keyBindings = new Set(["F3", "F4", "F7", "F10"]);
        this.ccAgentConfig.chat = false;
        this.ccAgentConfig.routing = "content";
        this.switchBoardConfig = new AppConfig();
        this.switchBoardConfig.switchboard = true;
        this.switchBoardConfig.keyBindings = new Set(["F3", "F4", "F7", "F8", "F9", "F10"]);
        this.switchBoardConfig.chat = true;
        this.switchBoardConfig.routing = "content";
    }
}
exports.default = applicationConfiguration;
